import {
  CommonStylesDefaultValues,
  CommonStylesDefaultValuesWithTextPosition
} from 'cms/cms-shared/common-settings-styles/common-settings-styles.models';
import { CommonStylesImageValues } from 'cms/cms-shared/common-settings-styles/image/common-settings-styles-image.models';
import { IdtComponentCmsDefinition, CmsComponentGroups } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { TextPaddingDefaultSettings } from 'extensions/core/piece-text/front/models/piece-text.models';

import { PieceVideoSettings } from './models/piece-video.models';


export const PieceVideoDefinition: IdtComponentDefinition = {
  id: 'piece-video',
  role: IdtComponentRole.Piece,
  numSlots: 0
};

export const PieceVideoCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Video',
  group: CmsComponentGroups.Media,
  availablePlatforms: ['web', 'apps'],
  initialSettings: (): PieceVideoSettings => {
    return {
      general: {
        clickToPlayPause: true,
        loop: false,
        link: undefined,
        landscapePosterImage: undefined,
        portraitPosterImage: undefined,
        width: undefined,
        autoPlay: false,
        typeOfVideo: 'own',
        marquee: {
          marqueeStatus: false,
          marqueeDurationDesktop: 20,
          marqueeDurationMobile: 5
        },
        showControls: true,
        showPositionControls: false,
        showMediaAudio: false,
        audioIconPosition: 'top-left',
        enableFallbackStaticVideo: false,
        ...TextPaddingDefaultSettings
      },
      styles: {
        ...CommonStylesDefaultValues,
        ...CommonStylesImageValues,
        ...CommonStylesDefaultValuesWithTextPosition,
        responsiveConfig: []
      }
    };
  }
};
